import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { EstimativaStatusConstants } from 'src/app/models/constants/constants';
import { DeletarEstimativa } from 'src/app/models/deletar-estimativa.model';
import { EstimativaService } from 'src/app/services/estimativa.service';
import { Misc } from '../../util/misc';
import { ToastrComponent } from '../../util/toastr/toastr.component';

@Component({
  selector: 'app-price-estimativa-excluir-dialog',
  templateUrl: './price-estimativa-excluir-dialog.component.html',
  styleUrls: ['./price-estimativa-excluir-dialog.component.scss']
})
export class PriceEstimativaExcluirDialogComponent implements OnInit, OnDestroy {

  basicForm: UntypedFormGroup;
  loading: boolean = false;
  textButton: string;
  private subscription = new Subscription();

  constructor(
    private estimativaService: EstimativaService,
    public misc: Misc,
    public toastr: ToastrComponent,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<PriceEstimativaExcluirDialogComponent>) {
    this.createForm();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  ngOnInit() {
    this.textoBotao();
  }

  createForm() {
    this.basicForm = this.fb.group({
      textoExclusao: [null, Validators.required]
    })
  }

  textoBotao() {
    this.textButton = this.data.estimativaStatusId === EstimativaStatusConstants.ID_ESTIMATIVA_ELABORACAO ? "Descartar" : "Reprovar"
  }

  descartarEstimativa() {

    this.loading = true;

    const estimativaDescartar = {
      EstimativaId: this.data.id,
      StatusId: this.data.estimativaStatusId,
      UsuarioId: this.data.usuarioId,
      Comentario: this.basicForm.value.textoExclusao

    } as DeletarEstimativa

    if (this.data.estimativaStatusId === EstimativaStatusConstants.ID_ESTIMATIVA_ELABORACAO) {
      this.subscription = this.estimativaService.descartarEstimativa(estimativaDescartar).subscribe({
        next: result => {
          this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Estimativa descartada com sucesso.');
        },
        error: error => {
          this.misc.processError(error, 'Não foi possível descartar a estimativa.');
        }
      });

      this.subscription.add(() => {
        this.loading = false;
        this.dialogRef.close(true);  
      });
    }

    if (this.data.estimativaStatusId === EstimativaStatusConstants.ID_ESTIMATIVA_APROVADA) {
      this.subscription = this.estimativaService.reprovarEstimativa(estimativaDescartar).subscribe({
        next: result => {
          this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Estimativa reprovada com sucesso.');
        },
        error: error => {
          this.misc.processError(error, 'Não foi possível reprovar a estimativa.');
        }
      });

      this.subscription.add(() => {
        this.loading = false;
        this.dialogRef.close(true);  
      });
    }
  }

  close() {
    this.dialogRef.close();
  }
}
